module.exports = __webpack_public_path__ + "img/Rectangle-2.e6bbfaf9.png";